export default __webpack_public_path__ + "static/media/water-drop 3.761e01d5.svg";